// KWANKGM04050_借入申込内容照会画面
import React from 'react';
import TopArea from '../../molecules/TopArea';
import Reception from '../../templates/Reception';
import { ShelfInfoObj, SetShelfInfo } from '../../types/FileUpload';
import FileUpload from '../../templates/FileUpload';
import Agreement from '../../templates/Agreement';
import { ParentShelf, ChildShelf, Content, GuarantorInfo } from '../../types/Template';
import FooterBorrowingApplicationDetailsInquiry from '../../organisms/FooterBorrowingApplicationDetailsInquiry';
import { KWANKGM04050A01, KWANKGM04050A02 } from '../../const/api_modules';
import LoadingModal from '../../molecules/LoadingModal';
import OnlineIdentificationDialog from '../../molecules/OnlineIdentificationDialog';
import ChangeRequest from '../../templates/ChangeRequest';

interface Props {
  looks_inactive: boolean;
  parent_shelfs: ParentShelf[];
  child_shelfs: ChildShelf[];
  contents: Content[];
  setParentShelfs: React.Dispatch<React.SetStateAction<ParentShelf[]>>;
  setChildShelfs: React.Dispatch<React.SetStateAction<ChildShelf[]>>;
  setContents: React.Dispatch<React.SetStateAction<Content[]>>;
  reception_id: number;
  status_code: number;
  shelf_info: ShelfInfoObj;
  setShelfInfo: SetShelfInfo;
  reception_cd: string;
  reception_sub_cd: string;
  ident_lv1_cd: string;
  ident_lv2_cd: string;
  ident_lv3_cd: string;
  label: string;
  status_name: string;
  display_reception_cd: boolean;
  guide_text: string;
  agreements: {
    guarantor: string;
    title: string;
    text: string;
  };
  guarantors_num: number;
  guarantor_info: GuarantorInfo;
  show_error_nav: boolean;
  display_status: boolean;
  requestModule: (module_name: string) => Promise<any>;
  is_loading: boolean;
  is_disagree: boolean;
  setShowErrorNav: React.Dispatch<React.SetStateAction<boolean>>;
  is_implement_online_identification: boolean;
  setIsImplementOnlineIdentification: React.Dispatch<React.SetStateAction<boolean>>;
  is_guarantor_agreement: boolean;
  setIsGuarantorAgreement: React.Dispatch<React.SetStateAction<boolean>>;
  modal_open: boolean;
  setModalnOpen: React.Dispatch<React.SetStateAction<boolean>>;
  change_request_message: string;
  is_change_request_message_registered: boolean;
  is_secured: boolean;
  is_unsecured: boolean;
  is_agricultural_modernization_funds: boolean;
  is_corporate_user?: boolean;
}

const ContentInquiry: React.FC<Props> = ({
  label,
  status_name,
  display_reception_cd,
  guide_text,
  parent_shelfs,
  child_shelfs,
  contents,
  setParentShelfs,
  setChildShelfs,
  setContents,
  looks_inactive,
  shelf_info,
  setShelfInfo,
  reception_id,
  reception_cd,
  reception_sub_cd,
  ident_lv1_cd,
  ident_lv2_cd,
  ident_lv3_cd,
  status_code,
  agreements,
  guarantors_num,
  guarantor_info,
  show_error_nav,
  display_status,
  requestModule,
  is_loading,
  is_disagree,
  setShowErrorNav,
  is_implement_online_identification,
  setIsImplementOnlineIdentification,
  is_guarantor_agreement,
  setIsGuarantorAgreement,
  modal_open,
  setModalnOpen,
  change_request_message,
  is_change_request_message_registered,
  is_secured,
  is_unsecured,
  is_agricultural_modernization_funds,
  is_corporate_user,
}) => {
  return (
    <>
      <TopArea
        reception_cd={reception_cd}
        label={label}
        status_name={status_name}
        display_reception_cd={display_reception_cd}
        guide_text={guide_text}
        display_status={display_status}
      />

      {/* お客様へのお知らせが登録されている場合は、変更依頼アコーディオンを表示 */}
      {is_change_request_message_registered && (
        <ChangeRequest change_request_message={change_request_message} />
      )}

      <Reception
        looks_inactive={looks_inactive}
        parent_shelfs={parent_shelfs}
        child_shelfs={child_shelfs}
        contents={contents}
        setParentShelfs={setParentShelfs}
        setChildShelfs={setChildShelfs}
        setContents={setContents}
        guarantors_num={guarantors_num}
        show_error_nav={show_error_nav}
        callApi={requestModule}
        guarantor_info={guarantor_info}
        setShowErrorNav={setShowErrorNav}
        setIsImplementOnlineIdentification={setIsImplementOnlineIdentification}
        is_corporate_user={is_corporate_user}
        is_agricultural_modernization_funds={is_agricultural_modernization_funds}
      />
      <FileUpload
        shelf_info={shelf_info}
        setShelfInfo={setShelfInfo}
        reception={{
          reception_id: reception_id,
          reception_cd: reception_cd,
          reception_sub_cd: reception_sub_cd,
          ident_lv1_cd: ident_lv1_cd,
          ident_lv2_cd: ident_lv2_cd,
          ident_lv3_cd: ident_lv3_cd,
          status_code: status_code,
        }}
        looks_inactive={true} // 提出書類を編集不可にするためtrueを渡す
        guarantors_num={guarantors_num}
        guarantor_info={guarantor_info}
        is_open_guarantor_1={guarantor_info.guarantor_1 && guarantor_info.is_guarantor}
        is_open_guarantor_2={guarantor_info.guarantor_2 && guarantor_info.is_guarantor}
        is_open_guarantor_3={guarantor_info.guarantor_3 && guarantor_info.is_guarantor}
        is_open_guarantor_4={guarantor_info.guarantor_4 && guarantor_info.is_guarantor}
        is_open_guarantor_5={guarantor_info.guarantor_5 && guarantor_info.is_guarantor}
        is_open_guarantor_6={guarantor_info.guarantor_6 && guarantor_info.is_guarantor}
        is_open_guarantor_7={guarantor_info.guarantor_7 && guarantor_info.is_guarantor}
        is_open_guarantor_8={guarantor_info.guarantor_8 && guarantor_info.is_guarantor}
        is_open_guarantor_9={guarantor_info.guarantor_9 && guarantor_info.is_guarantor}
        is_open_guarantor_10={guarantor_info.guarantor_10 && guarantor_info.is_guarantor}
        is_open_guarantor_11={guarantor_info.guarantor_11 && guarantor_info.is_guarantor}
        is_open_guarantor_12={guarantor_info.guarantor_12 && guarantor_info.is_guarantor}
        is_open_guarantor_13={guarantor_info.guarantor_13 && guarantor_info.is_guarantor}
        is_open_guarantor_14={guarantor_info.guarantor_14 && guarantor_info.is_guarantor}
        is_open_guarantor_15={guarantor_info.guarantor_15 && guarantor_info.is_guarantor}
        is_open_guarantor_16={guarantor_info.guarantor_16 && guarantor_info.is_guarantor}
        is_open_guarantor_17={guarantor_info.guarantor_17 && guarantor_info.is_guarantor}
        is_open_guarantor_18={guarantor_info.guarantor_18 && guarantor_info.is_guarantor}
        is_open_guarantor_19={guarantor_info.guarantor_19 && guarantor_info.is_guarantor}
        is_open_guarantor_20={guarantor_info.guarantor_20 && guarantor_info.is_guarantor}
        is_secured={is_secured}
        is_unsecured={is_unsecured}
        is_agricultural_modernization_funds={is_agricultural_modernization_funds}
      />
      <Agreement
        guarantor={agreements.guarantor}
        title={agreements.title}
        text={agreements.text}
        is_disagree={is_disagree}
        setIsGuarantorAgreement={setIsGuarantorAgreement}
      />
      <FooterBorrowingApplicationDetailsInquiry
        is_changing={false}
        is_staff={false}
        reception_cd={reception_cd}
        reception_id={reception_id}
        clickAgree={() => requestModule(KWANKGM04050A01)}
        clickDisagree={() => requestModule(KWANKGM04050A02)}
        status_code={status_code}
        is_implement_online_identification={is_implement_online_identification}
        is_guarantor_agreement={is_guarantor_agreement}
      />
      <OnlineIdentificationDialog
        is_guarantor={true}
        modal_open={modal_open}
        setModalnOpen={setModalnOpen}
      />
      <LoadingModal show={is_loading} />
    </>
  );
};

export default ContentInquiry;
